import './App.css'
import "aos/dist/aos.css";
import AOS from "aos";
import { Routes, Route } from "react-router-dom";
import Home from './components/Home/Home'
import ImageDetails from "./components/ImageDetails/ImageDetails";
import NotFound from "./components/NotFound/NotFound";
import AboutMe from "./components/AboutMe/AboutMe";
import Contact from "./components/Contact/Contact";
import { useEffect } from 'react';

function App() {

useEffect(() => {
    AOS.init();
  }, []);

  return (
    <section id='app'>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/photo/:id" element={<ImageDetails />} />
        <Route path="/about-me" element={<AboutMe />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </section>
  )
}

export default App
